import classnames from 'classnames';
import { forwardRef, HTMLProps, memo } from 'react';

import styles from './aiBanner.module.scss';

type AiBannerProps = HTMLProps<HTMLDivElement>;

/**
 * Renders a banner that is used for every AI related content, such as
 * conversation summaries.
 */
export const AiBanner = memo(
  forwardRef<HTMLDivElement>(function AiBanner(
    { className, children, ...restProps }: AiBannerProps,
    ref,
  ) {
    return (
      <div
        ref={ref}
        className={classnames(styles.root, className)}
        {...restProps}
      >
        {children}
      </div>
    );
  }),
);
